module.exports = __webpack_public_path__ + "static/img/img-6.ece87a94.png";